module.exports = __webpack_public_path__ + "img/emotional-development1.1ac9a8d1.png";